export const horizontalPadding: string = "6.25vw";

export const bodyBackgroundColor: string = "#f4f6f9";